import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-slate-900 text-white py-20 px-4 overflow-hidden" data-id="element-42">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-slate-950 opacity-80" data-id="element-43" />

      <div className="relative max-w-4xl mx-auto flex flex-col items-center text-center z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-8" data-id="element-45">
          <span className="inline-block py-1 px-3 rounded-full bg-amber-500/10 text-amber-400 text-sm font-medium tracking-wide mb-6 border border-amber-500/20" data-id="element-46">
            PARA MUJERES DE 65+ AÑOS
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-amber-500" data-id="element-47">
            ¿Otra vez el reloj marca las{' '}
            <span className="text-amber-400" data-id="element-48">3 AM</span> y tú sigues despierta?
          </h1>
          <p className="text-xl md:text-2xl text-slate-300 font-serif italic max-w-2xl mx-auto" data-id="element-49">
            "Para la mujer que extraña lo que se siente despertar con una
            sonrisa..."
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-3xl mb-10 relative group" data-id="element-50">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-300 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-1000" data-id="element-51"></div>
          <img src="https://cdn.magicpatterns.com/uploads/f4VK2HYKuJ3AkiBPxnWLWK/heylloyd-_imagen_1.png" alt="Mujer despierta a las 3AM mirando el reloj" className="relative rounded-xl shadow-2xl w-full border border-slate-700/50" data-id="element-52" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-53">
          <button onClick={() => {
          document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all transform hover:-translate-y-1 flex items-center gap-2 group" data-id="element-54">
            ¡QUIERO DORMIR PROFUNDO HOY!
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-55" />
          </button>
          <p className="mt-4 text-slate-400 text-sm" data-id="element-56">
            Oferta especial por tiempo limitado
          </p>
        </motion.div>
      </div>
    </section>;
}